'use client'

import ChatModalHeader from '@/views/chat/chat-modal-header'
import { Loader2 } from 'lucide-react'
import { useChatStore } from '@/store/chat.store'
import { useTranslations } from 'next-intl'

const SecondChatArea = () => {
  const t = useTranslations('chat')
  const comm100IntegrationId = useChatStore(state => state.comm100IntegrationId)
  const comm100SiteId = useChatStore(state => state.comm100SiteId)
  const comm100Url = useChatStore(state => state.comm100Url)

  const generateSecondChatIframeSrc = () => {
    if (!comm100Url) return ''

    const url = new URL(comm100Url)
    url.searchParams.set('siteId', comm100SiteId)
    url.searchParams.set('planId', comm100IntegrationId)

    return url.toString()
  }

  const secondChatIframeSrc = generateSecondChatIframeSrc()

  return (
    <div className='flex size-full flex-col'>
      <ChatModalHeader />

      <div className='relative flex flex-1 flex-col'>
        {secondChatIframeSrc && <iframe src={secondChatIframeSrc} className='relative z-20 flex-1' />}

        <div className='absolute inset-0 z-10 flex items-center justify-center'>
          <div className='text-muted-foreground flex flex-col items-center justify-center gap-2 text-xs font-medium'>
            <Loader2 className='size-4 animate-spin' />
            <p>{t('preparing')}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SecondChatArea
